import { openDrawerPane } from 'owa-drawer';
import { flexPaneOpened } from 'owa-suite-header-apis';
import { triggerResizeEvent } from 'owa-resize-event';

export default function openHeaderPane(paneId: string, targetWindow?: Window): void {
    openDrawerPane(paneId, targetWindow);
    flexPaneOpened(paneId);
    triggerResizeEvent();
}
